export default "__VITE_ASSET__7fd2467b__"